<template>
    <section class="heroes">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h5>Герои месяца</h5>
                </div>
            </div>
            <div class="heroes-block-items">
                <div class="row">
                    <div class="col-md-12">
                        <div class="row items">
                            <div class="item">
                                <h6>Может быть это вы?</h6>

                                <div v-if="topHomeFoundVolunteer !== null">
                                    <a :href="`/user/${topHomeFoundVolunteer.id}/profile`">
                                        <img src="/assets/images/main_page/heroes-one.svg" alt=""/>
                                    </a>
                                    <div>
                                        <p v-if="topHomeFoundVolunteer.found_home_during_month_qty && topHomeFoundVolunteer.month">
                                            <a class="block" :href="`/user/${topHomeFoundVolunteer.id}/profile`">{{ topHomeFoundVolunteer.name }}</a>
                                            {{topHomeFoundVolunteer.found_home_during_month_qty}} животных пристроено за {{topHomeFoundVolunteer.month}}
                                        </p>
                                    </div>



                                </div>
                                <div v-else>
                                    <img src="/assets/images/main_page/heroes-one.svg" alt="" />
                                    <p>Волонтер месяца</p>
                                </div>

                            </div>
                            <div class="item">
                                <h6>Ваш проект?</h6>

                                <div v-if="topDonatedProject !== null">
                                    <a :href="`/projects/${topDonatedProject.id}`">
                                        <img src="/assets/images/main_page/heroes-two.svg" alt=""/>
                                    </a>
                                    <div>
                                        <p v-if="topDonatedProject.donated_during_month && topDonatedProject.month">
                                            <a class="block" :href="`/projects/${topDonatedProject.id}`">{{ topDonatedProject.name }}</a>
                                            Проект поддержали на {{topDonatedProject.donated_during_month}} BYN за {{topDonatedProject.month}}
                                        </p>
                                    </div>

                                </div>

                                <div v-else>
                                    <img src="/assets/images/main_page/heroes-two.svg" alt="" />
                                    <p>Компания месяца</p>
                                </div>
                            </div>
                            <div class="item">

                                <h6>Может быть это вы?</h6>

                                <div v-if="topDonator !== null">
                                    <a :href="`/user/${topDonator.id}/profile`">
                                        <img src="/assets/images/main_page/heroes-three.svg" alt=""/>
                                    </a>
                                    <div>
                                        <p v-if="topDonator.donated_during_month && topDonator.month">
                                            <a class="block" :href="`/user/${topDonator.id}/profile`">{{ topDonator.name }}</a>
                                             {{topDonator.donated_during_month}} BYN cредств пожертвовано за {{topDonator.month}}
                                        </p>
                                    </div>
                                </div>

                                <div v-else>
                                    <img src="/assets/images/main_page/heroes-three.svg" alt="" />
                                    <p>Жертвователь месяца</p>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-center">
                            <a href="/auth/register" class="btn">Присоединиться к сообществу</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>


<script>

export default {

    props: ['topHomeFoundVolunteer','topDonator', 'topDonatedProject'],
    data(){
        return{
        }
    },

}

</script>

<style lang="scss">

.heroes{
    background: #ffffff;
    font-family: 'Comfortaa', cursive;
    padding: 45px 0;
    h5{
        font-size: 36px;
        font-weight: bold;
        margin-bottom: 45px;
        color: #333333;
    }
    .items{
        margin-bottom: 50px;
        .item{
            width: 33.33%;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            text-align: center;
            height: 100%;
            h6{
                color: #333333;
                font-size: 22px;
                font-weight: bold;
            }
            p{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                color: #2E76E4;
                font-size: 14px;
                margin-bottom: 30px;
                text-align: center;
                img{
                    margin-right: 2px;
                }
            }
            .heroes-btn{
                display: block;
                padding: 10px 20px;
                border-radius: 45px;
                border: none;
                font-weight: bold;
                font-size: 12px;
            }
            &:nth-child(1){
                .heroes-btn{
                    background: #EAF1FC;
                    color: #2E76E4;
                }
            }
            &:nth-child(2){
                .heroes-btn{
                    background: rgba(108, 77, 187, 0.1);
                    color: #6C4DBB;
                }
            }
            &:nth-child(3){
                .heroes-btn{
                    background: rgba(238, 115, 114, 0.1);
                    color: #EE7372;
                }
            }
        }
    }
}

@media only screen and (max-width: 992px){
    .heroes h5{
        text-align: center;
    }
    .heroes .items{
        justify-content: center;
    }

    .heroes .items .item{
        width: 50%;
        margin-bottom: 20px;
    }
}

@media only screen and (max-width: 768px){
    .heroes h5{
        font-size: 26px;
    }
}

@media only screen and (max-width: 600px) {
    .heroes {
        .items{
            justify-content: center;
            .item{
                width: 90%;
            }
        }
    }
}
</style>
